<template>
    <footer class="main-footer">
        <div class="pull-right hidden-xs">
            <b>Versione</b> {{ version }}
        </div>
        <strong>Copyright © {{ new Date().getFullYear() }} <a href="http://www.cinescatti.it">Cinescatti</a>.</strong>
        Tutti i diritti riservati.
    </footer>
</template>

<script>
  export default {
    data () {
      return {
        version: process.env.VERSION
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/layout/Foot.vue